import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  tableCell: {
    borderBottom: 'none',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
}));
